import { createI18n } from 'vue-i18n';
// Side-effect: registers jweather.localize/localeDateNames for legacy code
// (incl. the Vue-bundled CanvasChart) on pages without a legacy bundle.
import '../../../UI/LegacyLocalization.js';
import en from './locales/en.json';
import fr from './locales/fr.json';

export const SUPPORTED_LOCALES = ['en', 'fr'];
export const DEFAULT_LOCALE = 'en';

// Normalize a BCP 47 tag (e.g. "en-US") to a supported locale, falling back to the default.
export function resolveLocale(candidate) {
  const language = String(candidate || '').toLowerCase().split('-')[0];

  return SUPPORTED_LOCALES.includes(language) ? language : DEFAULT_LOCALE;
}

// The active instance, for translating outside component setup (Pinia stores,
// helpers). Components should keep using useI18n().
export let i18n = null;

// Shared factory so every page entry configures i18n identically.
// A ?lang= query param (used by the native app webviews, and handy for
// testing/QA on any page) overrides the locale passed by main.js;
// unsupported values fall through resolveLocale to the default.
export function createJwxI18n(locale = DEFAULT_LOCALE) {
  if (typeof window !== 'undefined') {
    const langParam = new URLSearchParams(window.location.search).get('lang');
    if (langParam) locale = langParam;
  }

  // Localization bridge for legacy jweather code (UI/*.js): jweather.localize
  // reads this at call time; pages without JWX render English fallbacks.
  if (typeof window !== 'undefined') {
    window.jwxTranslate = (key, fallback, params) => {
      const { t, te } = i18n.global;
      return te(key) || te(key, DEFAULT_LOCALE) ? t(key, params || {}) : fallback;
    };
  }

  const resolvedLocale = resolveLocale(locale);

  // Locale code for legacy chart date names (UI/CanvasChart.js localeNames).
  if (typeof window !== 'undefined') {
    window.jwxLocale = resolvedLocale;
  }

  i18n = createI18n({
    legacy: false,
    locale: resolvedLocale,
    fallbackLocale: DEFAULT_LOCALE,
    // Upgrade messaging carries <strong> markup rendered via v-html.
    warnHtmlMessage: false,
    messages: { en, fr },
  });

  return i18n;
}
